/**
 * Utilitário centralizado para trabalhar com ícones do Material-UI
 * Evita duplicação de código em múltiplos arquivos
 */
import * as MuiIcons from '@mui/icons-material';
import React from 'react';

/**
 * Retorna o componente de ícone (classe/função) baseado no nome
 * Útil para passar como prop ou armazenar em arrays
 * @param {string} iconName - Nome do ícone (ex: 'Dashboard', 'Person', 'Edit')
 * @returns {React.Component} Componente de ícone ou HelpOutline como fallback
 */
export const getIconClass = (iconName) => {
  return MuiIcons[iconName] || MuiIcons.HelpOutline;
};

/**
 * Retorna o elemento JSX renderizado do ícone
 * Útil para usar diretamente em JSX/JSX
 * @param {string} iconName - Nome do ícone (ex: 'Dashboard', 'Person', 'Edit')
 * @returns {React.Element} Elemento JSX do ícone
 */
export const getIconComponent = (iconName) => {
  const IconComponent = MuiIcons[iconName];
  return IconComponent ? React.createElement(IconComponent) : React.createElement(MuiIcons.HelpOutline);
};
